const DataBox = ({ icon, label, children, directChild, parentClass = "" }) => {
  return (
    <div className={"data-box" + parentClass}>
      <div className="media">
        <img src={icon} className="align-self-center" alt="job" />
        <div className="media-body">
          <label>{label}</label>
          {directChild ? children : <h4 className="text-wrap text-break word-break"> {children}</h4>}
        </div>
      </div>
    </div>
  );
};
export default DataBox;
